import React, { useEffect, useState } from 'react';
import FacebookIcon from '@material-ui/icons/Facebook';
import InstagramIcon from '@material-ui/icons/Instagram';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import TwitterIcon from '@material-ui/icons/Twitter';
import { NavLink } from 'react-router-dom';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import { Divider, IconButton, Link } from '@material-ui/core';
import { LocationOnOutlined, MailOutlineRounded, PhoneOutlined } from '@material-ui/icons';
import classes from './Footer.module.css'
import Aux from '../../../hoc/AuxComponent'
import moment from 'moment';

var d = new Date();
var currentYear = d.getFullYear();

const Footer = (props) => {
    const theme = useTheme();
    const smallScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const extraSmallScreen = useMediaQuery(theme.breakpoints.down('xs'));
    const [mobile, setMobile] = useState();
    const [shopOpen, setShopOpen] = useState(props.settings.isOpen || true);

    useEffect(() => {
        if (smallScreen || extraSmallScreen)
            setMobile(true);
        else if (!smallScreen && !extraSmallScreen)
            setMobile(false)
        setShopOpen(props.settings.isOpen);
    }, [smallScreen, extraSmallScreen, props]);

    const checkDateClosed = (dayNum) => {
        let currentDate = new Date();
        let dayCount = currentDate.getDay();
        let difference = 0;

        for(let i = 0; i < 7; i++){
            if(dayCount === dayNum){
                break;
            }
            else{
                difference++;
                dayCount++;
            }
            if (dayCount > 6){ dayCount = 0 }
        }
        
        let targetDate = new Date(currentDate);
        targetDate.setDate(targetDate.getDate() + difference);
        let returnedDate = moment(targetDate).format('MM/DD');
        
        if(props.datesClosed && props.datesClosed.dates) {
            for (const [key] of Object.entries(props.datesClosed.dates)){
                if(returnedDate === moment(key).format('MM/DD')){
                    return true;
                }
            }
        }
        return false;
    }

    return (
        <React.Fragment>
            <div id="row" className={classes.Footer}>
                <div className={[classes.Column, classes.Sitemap].join(' ')}>
                    <Aux>
                        {shopOpen?<NavLink className={classes.Link} activeClassName={classes.ActiveLink} to="/shop">Shop</NavLink>:
                        <small style={{fontSize:'15px', color:'grey'}}><s>Shop</s> (Closed until Spring)</small>}
                        <NavLink className={classes.Link} activeClassName={classes.ActiveLink} to="/equipment">Used Equipment</NavLink>
                        <NavLink className={classes.Link} activeClassName={classes.ActiveLink} to="/services">Services</NavLink>
                        <NavLink className={classes.Link} activeClassName={classes.ActiveLink} to="/careers">Careers</NavLink>
                        <NavLink className={classes.Link} activeClassName={classes.ActiveLink} to="/contact">Contact Us</NavLink>
                        <NavLink className={classes.Link} activeClassName={classes.ActiveLink} to="/history"> History</NavLink>
                        <NavLink className={classes.Link} activeClassName={classes.ActiveLink} to="/privacy"> Privacy Policy</NavLink>
                        <NavLink className={classes.Link} activeClassName={classes.ActiveLink} to="/accessibility"> Accessibility</NavLink>
                        
                    </Aux>
                    {!smallScreen ?
                        <Divider style={{ background: '#ffc107', marginTop: '5px', width: '120%', marginBotton: '0px', marginLeft: '-10%' }}></Divider>
                        : <Divider style={{ background: '#ffc107', marginTop: '5px', width: '100%', marginBotton: '0px', marginLeft: '0%' }}></Divider>}
                </div >

            </div>

            <div id="row" className={classes.Footer}>{/* 
                <div id="address" className={[classes.Column, classes.Address].join(' ')}>


                </div> */}

                <div id="newsletter" className={[classes.Column, classes.Newsletter].join(' ')}>

                    <p className={classes.Logo}> Gee Tee Holdings Inc.</p>
                    <div>
                        {props.social && props?.social.facebook ?
                        <Link target="_blank" rel="noopener" href={props.social.facebook} >
                            <IconButton color="primary" aria-label="facebook" >
                                <FacebookIcon />
                            </IconButton>
                        </Link>
                        : null}
                        {props.social && props?.social.instagram ?
                        <Link target="_blank" rel="noopener" href={props.social.instagram} >
                            <IconButton color="primary" aria-label="instagram"  >
                                <InstagramIcon />
                            </IconButton>
                        </Link>
                        : null}
                        {props.social && props?.social.twitter ?
                        <Link target="_blank" rel="noopener" href={props.social.twitter} >
                            <IconButton color="primary" aria-label="twitter"  >
                                <TwitterIcon />
                            </IconButton>
                        </Link>
                        : null}
                        {props.social && props.social.linkedIn ?
                        <Link target="_blank" rel="noopener" href={props.social.linkedIn} >
                            <IconButton color="primary" aria-label="linkedIn"  >
                                <LinkedInIcon />
                            </IconButton>
                        </Link>
                        : null}
                    </div>

                </div>

                <div style={{ marginBottom: '8px' }}>
                    <h3>Operation Hours</h3>
                    {!props.loading && props.settings && <table>
                        <tbody>
                            <tr><th>Sunday:&nbsp;&nbsp;</th><td>{checkDateClosed(0) || props.settings.operatingHours.Sunday.closed 
                                ? 'Closed' 
                                : `${moment(props.settings.operatingHours.Sunday.openTime).format('hA')} - ${moment(props.settings.operatingHours.Sunday.closeTime).format('hA')}`}</td></tr>
                            <tr><th>Monday:&nbsp;&nbsp;</th><td>{checkDateClosed(1) || props.settings.operatingHours.Monday.closed 
                                ? 'Closed' 
                                : `${moment(props.settings.operatingHours.Monday.openTime).format('hA')} - ${moment(props.settings.operatingHours.Monday.closeTime).format('hA')}`}</td></tr>
                            <tr><th>Tuesday:&nbsp;&nbsp;</th><td>{checkDateClosed(2) || props.settings.operatingHours.Tuesday.closed 
                                ? 'Closed' 
                                : `${moment(props.settings.operatingHours.Tuesday.openTime).format('hA')} - ${moment(props.settings.operatingHours.Tuesday.closeTime).format('hA')}`}</td></tr>
                            <tr><th>Wednesday:&nbsp;&nbsp;</th><td>{checkDateClosed(3) || props.settings.operatingHours.Wednesday.closed 
                                ? 'Closed' 
                                : `${moment(props.settings.operatingHours.Wednesday.openTime).format('hA')} - ${moment(props.settings.operatingHours.Wednesday.closeTime).format('hA')}`}</td></tr>
                            <tr><th>Thursday:&nbsp;&nbsp;</th><td>{checkDateClosed(4) || props.settings.operatingHours.Thursday.closed 
                                ? 'Closed' 
                                : `${moment(props.settings.operatingHours.Thursday.openTime).format('hA')} - ${moment(props.settings.operatingHours.Thursday.closeTime).format('hA')}`}</td></tr>
                            <tr><th>Friday:&nbsp;&nbsp;</th><td>{checkDateClosed(5) || props.settings.operatingHours.Friday.closed 
                                ? 'Closed' 
                                : `${moment(props.settings.operatingHours.Friday.openTime).format('hA')} - ${moment(props.settings.operatingHours.Friday.closeTime).format('hA')}`}</td></tr>
                            <tr><th>Saturday:&nbsp;&nbsp;</th><td>{checkDateClosed(6) || props.settings.operatingHours.Saturday.closed 
                                ? 'Closed' 
                                : `${moment(props.settings.operatingHours.Saturday.openTime).format('hA')} - ${moment(props.settings.operatingHours.Saturday.closeTime).format('hA')}`}</td></tr>
                            <tr><th></th><td><small>* Weather Permitting</small></td></tr>
                        </tbody>
                    </table>}
                </div>
            </div>
            {!mobile ?

                <div className={classes.Footer} style={{ paddingBottom: '8px' }}>
                    {props.contact?.storePhone ?<div className={classes.InfoItem}><PhoneOutlined style={{ fontSize: 14 }} /><a href={"tel:+1" + props.contact.storePhone.replace(/-/gi, '')}>{props.contact.storePhone}</a></div> : null}
                    {props.contact?.email ?<div className={classes.InfoItem}><MailOutlineRounded style={{ fontSize: 14 }} /><a href={"mailto:" + props.contact.email}>{props.contact.email}</a></div> : null}
                    {props.contact?.location ?<div className={classes.InfoItem}><NavLink to="/contact"><LocationOnOutlined style={{ fontSize: 14 }} />{props.contact.location}</NavLink></div> : null}
                </div>
                :
                <div className={classes.Copyright} style={{ backgroundColor: '#333333', paddingBottom: '8px' }}>
                    {props.contact?.storePhone ?<div className={classes.InfoItem}><PhoneOutlined style={{ fontSize: 14 }} /><a href={"tel:+1" + props.contact.storePhone.replace(/-/gi, '')}> </a></div> : null}
                    {props.contact?.email ?<div className={classes.InfoItem}><MailOutlineRounded style={{ fontSize: 14 }} /><a href={"mailto:" + props.contact.email}> </a></div> : null}
                    {props.contact?.location ?<div className={classes.InfoItem}><NavLink to="/contact"><LocationOnOutlined style={{ fontSize: 14 }} /></NavLink></div> : null}
                </div>
            }

            <div className={classes.Copyright}>

                <small>&copy; Copyright {currentYear}, Gee Tee Holdings Inc.</small>
            </div>


        </React.Fragment>
    )
};

export default Footer;

